<template>
  <div class="appointment-freight-user">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>预约货运险用户</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="自定义检索">
            <el-select v-model="searchType" placeholder="请选择" @change="handleSearchTypeChange">
              <el-option label="按公司名称" value="1"></el-option>
              <el-option label="按手机号码" value="2"></el-option>
              <el-option label="按注册时间" value="4"></el-option>
              <el-option label="按价格方案" value="5"></el-option>
              <el-option label="按平台名称" value="6"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '1'">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '2'">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '4'">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item v-if="searchType === '5'">
            <el-select v-model="searchForm.priceId" placeholder="请选择价格方案">
              <el-option
                v-for="item in priceList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '6'">
            <el-select v-model="searchForm.appId" placeholder="请选择平台">
              <el-option
                v-for="item in appList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-input v-model="searchForm.channel" placeholder="渠道商" clearable></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">全部</el-button>
            <el-button type="primary" @click="handleCreateUser">创建万能保用户</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="company_name" label="公司" width="220" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.company_id > 0" class="company-link" @click="viewCompanyDetail(scope.row.company_id)">
              {{ scope.row.company_name }}
            </span>
            <span v-else>{{ scope.row.company_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" width="100" align="center"></el-table-column>
        <el-table-column prop="insurance_type" label="保险公司类型" width="250" show-overflow-tooltip :formatter="insuranceTypeFormat" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="160" align="center"></el-table-column>
        <el-table-column prop="app_name" label="平台名称" width="150" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道商" width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">
              {{ scope.row.channel_name }}({{ scope.row.alias }})
            </span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price_name" label="价格方案名称" width="180" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="settlement_channel" label="结算渠道" width="120" :formatter="settlementChannelFormat" align="center"></el-table-column>
        <el-table-column prop="general_policy_url" label="电子保单" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.general_policy_url" class="link" @click="viewUrl(scope.row.general_policy_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="agreement_url" label="协议文件" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.agreement_url" class="link" @click="viewUrl(scope.row.agreement_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="deposit" label="总充值金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="expense" label="消费金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="balance" label="账户余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="invoice" label="已开发票金额(元)" width="130" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_deposit" label="线下充值总金额(元)" width="150" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_expense" label="线下充值支出总金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_balance" label="线下充值当前余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="ds_deposit" label="鼎盛充值总金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="ds_expense" label="鼎盛支出总金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="ds_balance" label="鼎盛当前余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="220" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="disabled" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '锁定' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="500" align="center">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <template v-if="scope.row.disabled">
                <!-- 当用户被锁定时，只显示解锁按钮 -->
                <el-button
                  size="mini"
                  type="success"
                  @click="handleUpdateStatus(scope.row.id, false, 'status')">
                  解锁
                </el-button>
                <el-button size="mini" @click="viewDetail(scope.row)">详情</el-button>
                <el-button size="mini" @click="viewTrend(scope.row)">查看投保趋势</el-button>
                <el-button size="mini" @click="handleNote(scope.row)">备注</el-button>
                <el-button size="mini" @click="handleAgreement(scope.row)">录入线下协议/保单</el-button>
              </template>
              <template v-else>
                <!-- 当用户未被锁定时，显示所有操作按钮 -->
                <el-button size="mini" type="warning" @click="handleUpdateStatus(scope.row.id, true, 'status')">锁定</el-button>
                <el-button v-if="scope.row.company_id > 0" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" @click="handleChangeChannel(scope.row)">变更渠道</el-button>
                <el-button size="mini" @click="handleDeposit(scope.row)">充值</el-button>
                <el-button size="mini" @click="showPriceDetail(scope.row)">价格方案详情</el-button>
                <el-button size="mini" @click="viewDetail(scope.row)">详情</el-button>
                <el-button size="mini" @click="viewTrend(scope.row)">查看投保趋势</el-button>
                <el-button size="mini" @click="handleNote(scope.row)">备注</el-button>
                <el-button size="mini" @click="handleAgreement(scope.row)">录入线下协议/保单</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
    </el-card>
    
    <!-- 创建万能保用户弹窗 -->
    <CreateHyxUser 
      :visible.sync="showCreateDialog"
      @success="handleCreateSuccess"
      @close="handleCreateClose"
    />
    
    <!-- 编辑用户弹窗 -->
    <EditHyxUser 
      :visible.sync="showEditDialog"
      :user-data="currentUser"
      @success="handleEditSuccess"
      @close="handleDialogClose"
    />
    
    <!-- 变更渠道弹窗 -->
    <ChangeChannel 
      :visible.sync="showChangeChannelDialog"
      :user-id="currentUser.id"
      :current-channel-name="currentUser.channel_name"
      :current-channel-alias="currentUser.alias"
      @success="handleChangeChannelSuccess"
      @close="handleDialogClose"
    />
    
    <!-- 人工充值弹窗 -->
    <Deposit 
      :visible.sync="showDepositDialog"
      :user-id="currentUser.id"
      @success="handleDepositSuccess"
      @close="handleDialogClose"
    />
    
    <!-- 价格方案详情弹窗 -->
    <PriceDetail 
      :visible.sync="showPriceDetailDialog"
      :user-id="currentUser.id"
      @close="handlePriceDetailClose"
    />
    
    <!-- 用户详情弹窗 -->
    <UserDetail 
      :visible.sync="showUserDetailDialog"
      :user-id="currentUser.user_id"
      :user-data="currentUser"
      @close="handleUserDetailClose"
    />
    
    <!-- 投保趋势弹窗 -->
    <InsuranceTrend 
      :visible.sync="showInsuranceTrendDialog"
      :company-name="currentUser.company_name"
      @close="handleInsuranceTrendClose"
    />
    
    <!-- 备注弹窗 -->
    <Note 
      :visible.sync="showNoteDialog"
      :user-id="currentUser.id"
      :current-note="currentUser.note"
      @success="handleNoteSuccess"
      @close="handleDialogClose"
    />
    
    <!-- 录入线下协议/保单弹窗 -->
    <Agreement 
      :visible.sync="showAgreementDialog"
      :user-id="currentUser.id"
      @success="handleAgreementSuccess"
      @close="handleDialogClose"
    />
    
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { 
  hyxUserList, 
  getAppList, 
  getChannelList, 
  getInsuranceCompanyList,
  getHyxPriceList,
  getHyxUserPriceInfo,
  getHyxUserInfo,
  changeHyxUserChannel,
  manualHyxUserDeposit,
  hyxUserBalanceTransfer,
  addHyxUserNote,
  saveHyxUserPolicy,
  disabledHyxUser
} from '@/api/member'
import CreateHyxUser from './hyxComponents/CreateHyxUser.vue'
import EditHyxUser from './hyxComponents/EditHyxUser.vue'
import ChangeChannel from './hyxComponents/ChangeChannel.vue'
import Deposit from './hyxComponents/Deposit.vue'
import PriceDetail from './hyxComponents/PriceDetail.vue'
import UserDetail from './hyxComponents/UserDetail.vue'
import InsuranceTrend from './hyxComponents/InsuranceTrend.vue'
import Note from './hyxComponents/Note.vue'
import Agreement from './hyxComponents/Agreement.vue'
import { jsonToExcel } from './hyxComponents/utils/exportExcel.js'

export default {
  name: 'AppointmentFreightUser',
  components: {
    CreateHyxUser,
    EditHyxUser,
    ChangeChannel,
    Deposit,
    PriceDetail,
    UserDetail,
    InsuranceTrend,
    Note,
    Agreement
  },
  data() {
    return {
      loading: false,
      searchType: '1',
      searchForm: {
        companyName: '',
        mobile: '',
        dateRange: [],
        priceId: '',
        appId: '',
        channel: ''
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      appList: [],
      channelList: [],
      priceList: [],
      // 移除硬编码的insuranceTypeMap，改为动态获取
      insuranceCompanyList: [],
      insuranceTypeMap: {},
      settlementChannelMap: {
        1: '恒丰经纪',
        2: '中际心元',
        4: '鼎盛'
      },
      // 添加弹窗显示状态
      showCreateDialog: false,
      showEditDialog: false,
      showChangeChannelDialog: false,
      showDepositDialog: false,
      showPriceDetailDialog: false,
      showUserDetailDialog: false,
      showInsuranceTrendDialog: false,
      showNoteDialog: false,
      showAgreementDialog: false,
      
      // 当前操作的用户数据
      currentUser: {},
      currentUserId: null
    }
  },
  created() {
    this.fetchData()
    this.fetchAppList()
    this.fetchChannelList()
    this.fetchPriceList()
    // 获取保险公司列表
    this.fetchInsuranceCompanyList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          platform_type: 8,
          ...this.buildSearchParams()
        }
        
        const res = await hyxUserList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取预约货运险用户列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      switch (this.searchType) {
        case '1':
          if (this.searchForm.companyName) {
            params.company_name = this.searchForm.companyName
          }
          break
        case '2':
          if (this.searchForm.mobile) {
            params.mobile = this.searchForm.mobile
          }
          break
        case '4':
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
            params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
          }
          break
        case '5':
          if (this.searchForm.priceId) {
            params.price_id = this.searchForm.priceId
          }
          break
        case '6':
          if (this.searchForm.appId) {
            params.app_id = this.searchForm.appId
          }
          break
      }
      
      if (this.searchForm.channel) {
        // 这里需要根据实际需求处理渠道搜索
        params.channel_name = this.searchForm.channel
      }
      
      return params
    },
    
    // 获取平台列表
    async fetchAppList() {
      try {
        const res = await getAppList()
        this.appList = res.rows || []
      } catch (error) {
        console.error('获取平台列表失败:', error)
      }
    },
    
    // 获取渠道列表
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },
    
    // 获取价格方案列表
    async fetchPriceList() {
      try {
        const res = await getHyxPriceList()
        if (res.err_code === 0) {
          this.priceList = res.rows || []
        }
      } catch (error) {
        console.error('获取价格方案列表失败:', error)
      }
    },
    
    // 获取保险公司列表
    async fetchInsuranceCompanyList() {
      try {
        const res = await getInsuranceCompanyList({ type: 1 })
        if (res.err_code === 0) {
          // 构建保险公司类型映射
          const map = {}
          res.rows.forEach(item => {
            map[item.id] = item.name
          })
          this.insuranceTypeMap = map
          this.insuranceCompanyList = res.rows
        }
      } catch (error) {
        console.error('获取保险公司列表失败:', error)
      }
    },
    
    // 搜索类型变化
    handleSearchTypeChange() {
      // 重置搜索表单
      this.searchForm.companyName = ''
      this.searchForm.mobile = ''
      this.searchForm.dateRange = []
      this.searchForm.priceId = ''
      this.searchForm.appId = ''
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        companyName: '',
        mobile: '',
        dateRange: [],
        priceId: '',
        appId: '',
        channel: ''
      }
      this.searchType = '1'
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 创建用户
    handleCreateUser() {
      this.showCreateDialog = true
    },
    
    // 创建用户成功回调
    handleCreateSuccess() {
      // 重新加载数据
      this.fetchData()
    },
    
    // 创建用户关闭回调
    handleCreateClose() {
      this.showCreateDialog = false
    },
    
    // 编辑用户成功回调
    handleEditSuccess() {
      this.fetchData()
      this.showEditDialog = false
    },
    
    // 变更渠道成功回调
    handleChangeChannelSuccess() {
      this.fetchData()
      this.showChangeChannelDialog = false
    },
    
    // 人工充值成功回调
    handleDepositSuccess() {
      this.fetchData()
      this.showDepositDialog = false
    },
    
    // 价格方案详情关闭回调
    handlePriceDetailClose() {
      this.showPriceDetailDialog = false
    },
    
    // 用户详情关闭回调
    handleUserDetailClose() {
      this.showUserDetailDialog = false
    },
    
    // 投保趋势关闭回调
    handleInsuranceTrendClose() {
      this.showInsuranceTrendDialog = false
    },
    
    // 备注成功回调
    handleNoteSuccess(note) {
      // 更新当前用户的备注
      const index = this.tableData.findIndex(item => item.id === this.currentUser.id)
      if (index !== -1) {
        this.tableData[index].note = note
      }
      this.showNoteDialog = false
    },
    
    // 录入协议/保单成功回调
    handleAgreementSuccess() {
      this.fetchData()
      this.showAgreementDialog = false
    },
    

    
    // 所有弹窗关闭回调
    handleDialogClose() {
      this.showCreateDialog = false
      this.showEditDialog = false
      this.showChangeChannelDialog = false
      this.showDepositDialog = false
      this.showPriceDetailDialog = false
      this.showUserDetailDialog = false
      this.showInsuranceTrendDialog = false
      this.showNoteDialog = false
      this.showAgreementDialog = false
    },
    
    // 导出Excel
    async handleExportExcel() {
      try {
        // 显示导出中提示
        const loading = this.$loading({
          lock: true,
          text: '正在导出数据...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 获取所有数据（可能需要分页处理）
        const params = {
          page: 1,
          rows: 10000, // 假设最多导出10000条数据
          platform_type: 8,
          ...this.buildSearchParams()
        };
        
        const res = await hyxUserList(params);
        
        if (res.err_code === 0) {
          const exportData = res.rows || [];
          
          // 定义表头
          const headers = [
            { title: '公司名称', key: 'company_name' },
            { title: '备注', key: 'note' },
            { title: '保险公司类型', key: 'insurance_type' },
            { title: '手机号', key: 'mobile' },
            { title: '平台名称', key: 'app_name' },
            { title: '渠道商', key: 'channel_name' },
            { title: '价格方案名称', key: 'price_name' },
            { title: '结算渠道', key: 'settlement_channel' },
            { title: '总充值金额(元)', key: 'deposit' },
            { title: '消费金额(元)', key: 'expense' },
            { title: '账户余额(元)', key: 'balance' },
            { title: '已开发票金额(元)', key: 'invoice' },
            { title: '线下充值总金额(元)', key: 'offline_deposit' },
            { title: '线下充值支出总金额(元)', key: 'offline_expense' },
            { title: '线下充值当前余额(元)', key: 'offline_balance' },
            { title: '鼎盛充值总金额(元)', key: 'ds_deposit' },
            { title: '鼎盛支出总金额(元)', key: 'ds_expense' },
            { title: '鼎盛当前余额(元)', key: 'ds_balance' },
            { title: '注册时间', key: 'created_at' },
            { title: '状态', key: 'disabled' }
          ];
          
          // 格式化数据
          const formattedData = exportData.map(item => {
            return {
              ...item,
              insurance_type: this.insuranceTypeMap[item.insurance_type] || '未知',
              settlement_channel: this.settlementChannelMap[item.settlement_channel] || '未知',
              deposit: formatMoney(item.deposit),
              expense: formatMoney(item.expense),
              balance: formatMoney(item.balance),
              invoice: formatMoney(item.invoice),
              offline_deposit: formatMoney(item.offline_deposit),
              offline_expense: formatMoney(item.offline_expense),
              offline_balance: formatMoney(item.offline_balance),
              ds_deposit: formatMoney(item.ds_deposit),
              ds_expense: formatMoney(item.ds_expense),
              ds_balance: formatMoney(item.ds_balance),
              created_at: formatDate(item.created_at),
              disabled: item.disabled ? '锁定' : '正常',
              channel_name: item.channel_name ? `${item.channel_name}(${item.alias})` : item.alias
            };
          });
          
          // 导出文件
          const fileName = `预约货运险用户列表_${new Date().toISOString().slice(0, 10)}.csv`;
          const success = jsonToExcel(formattedData, headers, fileName);
          
          if (success) {
            this.$message.success('导出成功');
          } else {
            this.$message.error('导出失败');
          }
        } else {
          this.$message.error('导出失败: ' + res.err_msg);
        }
        
        loading.close();
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$message.error('导出失败: ' + error.message);
      }
    },
    
    // 查看公司详情
    viewCompanyDetail(companyId) {
      this.$message.info(`查看公司详情，ID: ${companyId}`)
    },
    
    // 查看投保趋势
    viewTrend(row) {
      this.currentUser = row
      this.showInsuranceTrendDialog = true
    },
    
    // 编辑
    handleEdit(row) {
      this.currentUser = row
      this.showEditDialog = true
    },
    
    // 变更渠道
    handleChangeChannel(row) {
      this.currentUser = row
      this.showChangeChannelDialog = true
    },
    
    // 充值
    handleDeposit(row) {
      this.currentUser = row
      this.showDepositDialog = true
    },
    
    // 价格方案详情
    async showPriceDetail(row) {
      try {
        // 获取用户价格方案详情
        const res = await getHyxUserPriceInfo({ id: row.id })
        if (res.err_code === 0) {
          this.currentUser = { ...row, priceInfo: res.data }
          this.showPriceDetailDialog = true
        } else {
          this.$message.error('获取价格方案详情失败: ' + res.err_msg)
        }
      } catch (error) {
        console.error('获取价格方案详情失败:', error)
        this.$message.error('获取价格方案详情失败: ' + error.message)
      }
    },
    
    // 详情
    async viewDetail(row) {
      try {
        // 获取用户详情
        const res = await getHyxUserInfo({ id: row.user_id })
        if (res.err_code === 0) {
          this.currentUser = { ...row, userInfo: res.data }
          this.showUserDetailDialog = true
        } else {
          this.$message.error('获取用户详情失败: ' + res.err_msg)
        }
      } catch (error) {
        console.error('获取用户详情失败:', error)
        this.$message.error('获取用户详情失败: ' + error.message)
      }
    },
    
    // 备注
    handleNote(row) {
      this.currentUser = row
      this.showNoteDialog = true
    },
    
    // 录入线下协议/保单
    handleAgreement(row) {
      this.currentUser = row
      this.showAgreementDialog = true
    },
    
    
    // 查看URL
    viewUrl(url) {
      window.open(url, '_blank')
    },
    
    // 更新状态
    async handleUpdateStatus(userId, status, action) {
      try {
        // 获取要操作的用户信息，用于显示确认对话框
        const user = this.tableData.find(item => item.id === userId);
        const userName = user ? (user.mobile || user.username || userId) : userId;
        const tip = status ? '锁定' : '启用';
        
        // 显示确认对话框
        await this.$confirm(`您确认想要修改用户 ${userName} 的状态为"${tip}"吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 调用更新状态接口
        const params = {
          id: userId,
          disabled: status
        }
        
        const res = await disabledHyxUser(params)
        
        if (res.err_code === 0) {
          this.$message.success('修改成功')
          // 重新加载数据
          this.fetchData()
        } else {
          this.$message.error('修改失败: ' + res.err_msg)
        }
      } catch (error) {
        // 用户取消操作或API调用失败
        if (error !== 'cancel') {
          console.error('更新状态失败:', error)
          this.$message.error('修改失败: ' + (error.message || '未知错误'))
        }
      }
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 保险公司类型格式化
    insuranceTypeFormat(row, column, cellValue) {
      return this.insuranceTypeMap[cellValue] || '未知'
    },
    
    // 结算渠道格式化
    settlementChannelFormat(row, column, cellValue) {
      return this.settlementChannelMap[cellValue] || '未知'
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return formatMoney(cellValue)
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return formatDate(cellValue)
    }
  }
}
</script>

<style lang="less" scoped>
.appointment-freight-user {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .company-link, .link {
    color: #409EFF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .operation-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
    padding: 5px 0;
    
    /deep/ .el-button {
      margin: 2px 0;
    }
  }
}
</style>
